// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"38":"component---src-pages-projects-shallow-green-js","293":"component---src-pages-index-js","807":"component---src-pages-arti-js"}[chunkId] + "-" + {"38":"a212bc61697fb808f98a","293":"b6649fc8104268006e4d","807":"b20ca5ecffa89bd987ea"}[chunkId] + ".js";
};